module.exports = __webpack_public_path__ + "Pe-icon-7-stroke.b38ef310874bdd008ac1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/newtheme/fonts/Pe-icon-7-stroke.woff?d7yf1v
// module id = 864
// module chunks = 2